/* ========================================================================
 * Crebow Menu Vanilla JS v1.0.0
 *
 * GNU General Public License v2 or later
 * https://www.gnu.org/licenses/gpl-2.0.html
 *
 * author by Tomoya Matsumoto / crebow.info
 * https://crebow.info/
 * Copyright 2021 crebow.info
 *
 * ------------------------------------------------------------------------
 * 使い方
 * breakPoint     スマートフォン時のブレイクポイントを入力
 * menuButtonID   ボタンのID
 * navigationID   メニューのID
 * ------------------------------------------------------------------------
 * セッティング
 * HTMLの仕様にあわせて変更してください*/
const breakPoint     = 601;
const menuButtonID   = 'MenuButton';
const navigationID   = 'Navigation';
const activeClass    = 'js-active';

// ***************************************************************************
const menuButtonValue = document.getElementById(menuButtonID);
const navigationValue = document.getElementById(navigationID);
let   lastInnerWidth  = window.innerWidth;
function noScroll(event) {
  event.preventDefault();
}
// ***************************************************************************
//初回動作
if(menuButtonValue !== null || navigationValue !== null ){
	let MultipleClicks = 0; //多重クリック防止
	document.getElementById(menuButtonID).onclick = function() {
		if( MultipleClicks == 0 ){
			MultipleClicks = 1;
			// -+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
			// メニューボタンの挙動 & スクロールの制御
			if(menuButtonValue.classList.contains(activeClass) == true ) {
				menuButtonValue.classList.remove(activeClass);
				document.removeEventListener('touchmove', noScroll, { passive: false });
				document.removeEventListener('mousewheel', noScroll, { passive: false });
			}else{
				menuButtonValue.classList.add(activeClass);
				document.addEventListener('touchmove', noScroll, { passive: false });
				document.addEventListener('mousewheel', noScroll, { passive: false });
			}
			// -+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
			// メニューの挙動
			if(navigationValue.classList.contains(activeClass) == true ) {
				navigationValue.classList.remove(activeClass);
			}else{
				navigationValue.classList.add(activeClass);
			}
			setTimeout(function(){ MultipleClicks = 0; },300);
		}
	}
}

// *****************************************************************
//リサイズ時に再度セット
window.addEventListener( "resize", function () {
	if(lastInnerWidth != window.innerWidth) {
		lastInnerWidth = window.innerWidth;
		if(lastInnerWidth <= breakPoint){
			//SPリセット
			if(menuButtonValue !== null || navigationValue !== null ){
				if (menuButtonValue.classList.contains(activeClass) == true ) {
					menuButtonValue.classList.remove(activeClass);
					document.removeEventListener('touchmove', noScroll, { passive: false });
					document.removeEventListener('mousewheel', noScroll, { passive: false });
				}
				if (navigationValue.classList.contains(activeClass) == true ) {
					navigationValue.classList.remove(activeClass);
					document.removeEventListener('touchmove', noScroll, { passive: false });
					document.removeEventListener('mousewheel', noScroll, { passive: false });
				}
			}
		}else{
			//PCリセット
			if(menuButtonValue !== null || navigationValue !== null ){
				if (menuButtonValue.classList.contains(activeClass) == true ) {
					menuButtonValue.classList.remove(activeClass);
					document.removeEventListener('touchmove', noScroll, { passive: false });
					document.removeEventListener('mousewheel', noScroll, { passive: false });
				}
				if (navigationValue.classList.contains(activeClass) == true ) {
					navigationValue.classList.remove(activeClass);
					document.removeEventListener('touchmove', noScroll, { passive: false });
					document.removeEventListener('mousewheel', noScroll, { passive: false });
				}
			}
		}
	}
});
